
export enum PolicyStatusEnum {
    待生效 = 0,
    保障中 = 1,
    不在保 = 2
}